import React, { useEffect } from "react";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import TranslateButton from "../../TranslateButton/TranslateButton";
import "../../../style/jobCircular/jobCircularBBCSecondTime.css";
import CircularOne from "../../../images/Job Circular/Circular_BBC_Media_Action_Facilitator.jpg";
import CircularTwo from "../../../images/Job Circular/Circular_BBC_Media_Action_Facilitator_2.jpg";
import CircularThree from "../../../images/Job Circular/Circular_BBC_Media_Action_Facilitator_3.jpg";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

const JobCircularBBCSecondTime = () => {
  useEffect(() => {
    document.title = `AshroyAngon | We Are Hiring`;
  }, []);

  const shareUrl = "https://ashroyangon.org/we-are-hiring/upcoming-project";

  return (
    <>
      <Navbar />
      <TranslateButton />

      <div className="job_circular_second_time_section">
        {/* Header Background Part Start */}
        <div className="header_background">
          <div className="container wrapper">
            <h2>We Are Hiring</h2>
            <div className="social_share_button">
              <FacebookShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share facebook"}
                hashtag={"#facebook"}
              >
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share twitter"}
                hashtag={"#twitter"}
              >
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share linkedin"}
                hashtag={"#linkedin"}
              >
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div>
        {/* Header Background Part End */}

        <div className="job_circular_second_time_section_wrapper">
          <div className="container">
            <h2>We Are Hiring</h2>
            <img src={CircularOne} loading="lazy" alt="" />
            <img src={CircularTwo} loading="lazy" alt="" />
            <img src={CircularThree} loading="lazy" alt="" />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default JobCircularBBCSecondTime;
